import React, {useEffect, useState} from 'react';
import {Route, Routes} from "react-router-dom";
import ContentTop from "../../components/ContentTop";
import Manbalar from "./Manbalar";
import Edit from "./Edit";
import axios from "axios";
import {header} from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";

function Index() {
    const [month, setMonth] = useState(new Date().toISOString().slice(0,7))
    const [lmonth, setLmonth] = useState(month)
    const [data, setData] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/wateruse/index?month="+month, header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setData(res.data)
            }
        }
            fetchData()
    }, [month]);
    return (
        <div>
            <ContentTop>
                <ul className="content-top-left suv-omborlari">
                    <li>Suvdan foydalanish</li>
                </ul>
                <ul className="content-top-right">
                    <input type="month" className="form-control form-control-sm" onChange={e=>setLmonth(e.target.value)} value={lmonth}/>
                    &nbsp;&nbsp;&nbsp;
                    <button className="btn btn-outline-primary btn-sm" onClick={()=>setMonth(lmonth)}>Ok</button>
                </ul>
            </ContentTop>
            <div className="tabs-content table-box extra-tab-css">
                <Routes>
                    <Route path="/" element={<Manbalar month={month} data={data}/> }/>
                    <Route path="/edit" element={<Edit month={month} data={data} setData={setData}/>} />
                </Routes>
            </div>
        </div>

    );
}

export default Index;